import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';

import { SpecialNeedsEnum } from '@mopla/data-models';

import { Plus } from '../../icons';

import {
	AdditionalNeedsWrapper,
	AdditionalNeedText,
} from './PassengerCheckCard.styles';

export interface IAdditionalNeedsProps {
	bulkyLuggage?: boolean;
	specialNeeds?: SpecialNeedsEnum;
}

export const AdditionalNeeds: FC<IAdditionalNeedsProps> = ({
	bulkyLuggage,
	specialNeeds,
}) => {
	const { t } = useTranslation('checkIn');

	if (
		!bulkyLuggage &&
		(!specialNeeds || specialNeeds === SpecialNeedsEnum.NONE)
	) {
		return null;
	}

	const additionalNeeds = [
		bulkyLuggage && t('text.additional_bulky_luggage'),
		specialNeeds &&
			specialNeeds !== SpecialNeedsEnum.NONE &&
			t(`specialNeeds:text.${specialNeeds}`),
	]
		.filter(Boolean)
		.map((text, index) => (
			<AdditionalNeedText
				key={index}
				variant="body2"
				fontWeight={600}
				color="primary.dark"
			>
				<Plus /> {text}
			</AdditionalNeedText>
		));

	return (
		<AdditionalNeedsWrapper className="spaceBetween" gap={4}>
			<Typography variant="body2" color="primary.dark">
				{t('text.additional_needs')}
			</Typography>
			{additionalNeeds}
		</AdditionalNeedsWrapper>
	);
};
